import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/user.svg'


const _hoisted_1 = { class: "menu-header" }
const _hoisted_2 = {
  key: 0,
  class: "user-name center-h"
}
const _hoisted_3 = {
  key: 1,
  class: "user-name center-h"
}
const _hoisted_4 = { href: "Session/SignOut" }
const _hoisted_5 = { href: "Session/EditProfile" }
const _hoisted_6 = { href: "Session/ResetPassword" }
const _hoisted_7 = { href: "Session/SignIn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    class: "pr-4"
  }, {
    dropdown: _withCtx(() => [
      (_ctx.loggedIn)
        ? (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_4, [
                _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Sign out", -1)
                  ])),
                  _: 1,
                  __: [1]
                })
              ]),
              _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Edit Profile", -1)
                  ])),
                  _: 1,
                  __: [2]
                })
              ]),
              _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Reset Password", -1)
                  ])),
                  _: 1,
                  __: [3]
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_7, [
                _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Sign in", -1)
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "pr-4",
          src: _imports_0,
          height: "30",
          width: "30"
        }, null, -1)),
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
      ])
    ]),
    _: 1
  }))
}